import { render, staticRenderFns } from "./AutoAddItem.vue?vue&type=template&id=72b59e5a&scoped=true"
import script from "./AutoAddItem.vue?vue&type=script&lang=js"
export * from "./AutoAddItem.vue?vue&type=script&lang=js"
import style0 from "./AutoAddItem.vue?vue&type=style&index=0&id=72b59e5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b59e5a",
  null
  
)

export default component.exports